import React from 'react';
import { Container } from 'react-bootstrap';
import { ImageUrl } from '../../../../../Helpers/request';
import InstaIframe from '../../../InstaIframe';
import { LazyLoadImage } from "react-lazy-load-image-component";

const InstagramFeeds = () => {
  return (
    <div className="py-5">
      <Container className="containerV1">
        <div className="text-center mx-auto mb-5">
          <h3 className="title_heading mb-0 pb-0  d-block  fontMessiri">Get a Tour of our Social Media</h3>
          {/* <LazyLoadImage src={`${ImageUrl}theme/macau/line-black.png`} alt="" className="img-fluid" /> */}
        </div>
      </Container>
      <InstaIframe />
    </div>
  );
};

export default InstagramFeeds;
